export const BUILT_IN_TOOL_IDS = [
    'SWITCH_LANGUAGE',
    'GET_PROPERTY_LISTINGS',
    'VOICEMAIL_DETECTION',
];
export const BUILT_IN_TOOLS = [
    {
        id: 'SWITCH_LANGUAGE',
        label: 'Language switching',
        description: 'Switch between English and Spanish during calls',
        direction: 'BOTH',
    },
    {
        id: 'GET_PROPERTY_LISTINGS',
        label: 'Property listings',
        description: 'Look up and describe property listings',
        direction: 'BOTH',
    },
    {
        id: 'VOICEMAIL_DETECTION',
        label: 'Voicemail detection',
        description: 'Detect voicemail systems and leave a message automatically',
        direction: 'BOTH',
    },
];
//# sourceMappingURL=index.js.map